import { useState } from 'react'

import { Button } from '@atoms'

import timeFormatter from '@frontend/utils/timeFormatter'
import { scopedTranslation } from '@utils/I18n'

import { AddShiftsDialog } from './AddShiftsDialog'
import { useEventTimeZone } from './ShiftAuthoringContext'

const t = scopedTranslation('author_shifts')

type AddShiftButtonProps = {
  presetDate?: string | null
}

export function AddShiftButton({ presetDate = null }: AddShiftButtonProps) {
  const [open, setOpen] = useState(false)
  const timeZone = useEventTimeZone()

  return (
    <>
      {presetDate ? (
        <Button rank="link" size="sm" leadingIcon="plus" onClick={() => setOpen(true)}>
          {t('add_to_day', { day: timeFormatter.fromISO(presetDate, timeZone).toShortDate() })}
        </Button>
      ) : (
        <Button rank="primary" leadingIcon="plus" onClick={() => setOpen(true)}>
          {t('add_shifts')}
        </Button>
      )}
      {open && <AddShiftsDialog open={open} onOpenChange={setOpen} presetDate={presetDate} />}
    </>
  )
}
